import {cardTitle, primaryColor, secondaryColor, tertiaryColor, title} from "../../../nextjs-material-kit.js";
import imagesStyle from "../../../nextjs-material-kit/imagesStyles.js";
import { container } from "../../../nextjs-material-kit.js";

const teamStyle = (theme) => ({
  container: {
    ...container(theme),
  },
  btn: {
    marginLeft: "0px",
    marginTop: "15px",
    marginRight: "15px",
    float: "left",
    fontSize: "16px !important",
    fontFamily: "var(--font-brandon-grotesque) !important",
    fontWeight: 700,
    textTransform: "none",
    backgroundColor: "#095a70",
    marginBottom: "0px",
    lineHeight: "16px",
    display: "flex",
    boxShadow: "none",
    padding: "8px 30px",
  },
  favouriteIcon: {
    float: "right",
    marginLeft: "15px",
    cursor: "pointer",
  },
  primaryColor: {
    backgroundColor: primaryColor,
  },
  lightBlue: {
    backgroundColor: tertiaryColor,
  },
  lightGreen: {
    backgroundColor: secondaryColor,
  },
  title: {
    ...title,
    marginBottom: "1rem",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none",
  },
  ...imagesStyle,
  itemGrid: {
    // height: "100%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  },
  cardTitle: {
    ...cardTitle,
    fontFamily: "var(--font-brandon-grotesque)",
    fontWeight: 900,
    textAlign: "left",
    color: "#095A70",
    fontSize: "40px",
    paddingLeft: "0",
    lineHeight: 1,
  },
  cardSubTitle: {
    marginTop: "24px !important",
    fontFamily: "var(--font-brandon-grotesque)",
    textAlign: "left",
    color: secondaryColor,
    fontSize: "19px",
    margin: "0 !important",
  },

  noMargin: {
    padding: "0px !important",
  },
  smallTitle: {
    color: "#6c757d",
  },
  strong: {
    color: secondaryColor,
  },
  description: {
    color: "#000",
    fontFamily: "var(--font-brandon-grotesque)",
    fontSize: "16px",
    fontWeight: "100 !important",
    textAlign: "left",
    lineHeight: "1.15",
  },
  list: {
    listStyle: "none",
    paddingLeft: "0px !important",
    "& li": {
      fontSize: "14px",
    },
  },
  justifyCenter: {
    justifyContent: "center !important",
  },
  margin5: {
    margin: "5px",
  },
  imgBgWhite: {
    backgroundColor: "#fff",
  },
  floatRight: {
    float: "right",
    marginLeft: "15px",
    marginBottom: "15px",
  },
  floatLeft: {
    float: "left",
    textAlign: "left",
  },
  marginTop: {
    marginTop: "25px",
  },
  noLeftPadding: {
    paddingLeft: 0,
  },
});

export default teamStyle;
